import { api } from "../App";
import {
  SET_PARENT_MEETINGS_LIST,
  SET_PARENT_MEETINGS_ID,
  SET_PARENT_MEETINGS_ROOMS,
  SET_PARENT_MEETINGS_TEACHERS,
  SET_PARENT_MEETINGS_LOADING,
  SET_PARENT_MEETINGS_FILES_LIST,
  SET_PARENT_MEETINGS_FILE,
} from "./types";


export const getParentMeetingsList = (params) => async (dispatch, getState) => {
  console.log('params::: ', params);
  try {
    const urlParams = new URLSearchParams({ year: params.scYear, studyPeriod: params.studyPeriod }).toString();
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    const { data } = await api.get(`/parent_meetings?${urlParams}`);
    dispatch({ type: SET_PARENT_MEETINGS_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
}
export const getParentMeetingsById = (pmid) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    const { data } = await api.get(`/parent_meetings/${pmid}`);
    dispatch({ type: SET_PARENT_MEETINGS_ID, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
}

export const createParentMeetings = (info, params) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    const { data } = await api.post(`/parent_meetings`, { ...info, classes: [], });
    await dispatch(updateParentMeetings({ pmid: data.pmid, ...info, }))
    await dispatch(getParentMeetingsList(params))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
    return success
  }
}
export const updateParentMeetings = ({ pmid, ...data }) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    await api.put(`/parent_meetings/${pmid}`, data);
    await dispatch(getParentMeetingsById(pmid))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
    return success
  }
}

// фильтры
export const getParentMeetingsRooms = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    const { data } = await api.get('/parent_meetings/rooms');
    dispatch({ type: SET_PARENT_MEETINGS_ROOMS, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
}

// 
// export const getParentMeetingsTeachersClass = (rid) => async (dispatch, getState) => {
//   try {
//     dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
//     const { data } = await api.get(`/parent_meetings/${rid}`);
//     dispatch({ type: SET_PARENT_MEETINGS_TEACHERS, payload: data });
//   } catch (ERR) {
//   } finally {
//     dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
//   }
// }

export const createParentMeetingFile = (data, pmid,) => async (dispatch, getState) => {
  const fd = new FormData();
  fd.append("file", data);
  let success
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    await api.post(`/parent_meetings/${pmid}/file`, fd);
    await dispatch(getParentMeetingFileList(pmid))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
    return success
  }
}

export const getParentMeetingFile = (file_name, pmid) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    const { data } = await api.get(`/parent_meetings/${pmid}/file/${file_name}`);
    const result = await data.blob()
    const objectURL = URL.createObjectURL(result);
    dispatch({ type: SET_PARENT_MEETINGS_FILE, payload: objectURL });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
};
//список файлов
export const getParentMeetingFileList = (pmid) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    const { data } = await api.get(`/parent_meetings/${pmid}/file`);
    dispatch({ type: SET_PARENT_MEETINGS_FILES_LIST, payload: data });
  } catch (ERR) {
    dispatch({ type: SET_PARENT_MEETINGS_FILES_LIST, payload: [] });
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
};


// export const updateActType = (id, data) => async (dispatch, getState) => {
//   let success
//   try {
//     dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
//     await api.put(`/parent_meetings/${id}`, data);
//     await dispatch(getActTypes())
//     success = true
//   } catch (ERR) {
//   } finally {
//     dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
//     return success
//   }
// }

export const deleteParentMeeting = (id, params) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    await api.delete(`/parent_meetings/${id}`);
    await dispatch(getParentMeetingsList(params))
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
}
export const deleteParentMeetingFile = (pmid, file_name) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: true });
    await api.delete(`/parent_meetings/${pmid}/file/${file_name}`);
    await dispatch(getParentMeetingFileList(pmid))
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PARENT_MEETINGS_LOADING, payload: false });
  }
}